export default __webpack_public_path__ + "static/media/team.6dd16952.jpeg";